<template>
    <div id="entrancePc" :class="{'entrancePc-Back':currentTime > changeTime}">
        <div class="entrancePc-top" :class="{'entrancePc-top-Back':currentTime > changeTime}">
        </div>
        <div class="wqj-botBox">
            <community-comment></community-comment>
            <activity-rules></activity-rules>
        </div>
        <div class="ie" v-if="$utils.browser.isIE()"></div>
    </div>
    
</template>

<script>
import communityComment from './communityComment.vue';
import activityRules from './activityRules.vue';

export default {
    name: 'entrancePc',
    components: {communityComment,activityRules},
    data() {
        return {
            weiboDownloadUrl: '',
            gongzhonghaoDownloadUrl: '',
            changeTime: new Date('2023/01/10 10:00:00').getTime(),
            currentTime: new Date().getTime(),
        }
    },
    mounted(){
        if(this.currentTime > this.changeTime) {
            document.body.style.background = '#DB5353';

        }
    },
    methods: {
        toCommentReport() {
            let qudao = this.$utils.urlParam(window.location.href, 'qudao');
            let url = this.weiboDownloadUrl;
            if (qudao == 'gongzhonghao') {
                url = this.gongzhonghaoDownloadUrl;
            }
            let a = document.createElement("a");
            a.href = url;
            a.target = 'blank';
            a.click();
            a.remove();
        },
    }
}
</script>

<style>
body {
    background: #060815;
}


#entrancePc {
    width: 100%;
    height: 42.2rem;
    overflow: hidden;
    background: url('https://image.gamersky.com/webimg13/zt/22annual/pcbg.png') no-repeat top center / 100%;
    background-size: 100%;
    display: flex;
    justify-content: center;
}
.entrancePc-Back {
    background: #DB5353 !important;
}

.entrancePc-Back::after {
    position: absolute;
    top: 0;
    left: 0;
    content:'';
    width: 360px;
    height: 100%;
    background: url('../assets/image/entrance/thrigle.png') no-repeat top / 100% auto;
}
.entrancePc-top {
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -608px;
    display: flex;
    justify-content: center;
    width: 1218px;
    height: 100%;
    background: url('https://image.gamersky.com/webimg13/zt/22annual/pctop.png?sdfaf') no-repeat top center / 1218px auto;
}
.entrancePc-top-Back {
    background: url('https://image.gamersky.com/webimg13/zt/22annual/pctop_Back.png?dddd') no-repeat top center / 1218px auto;
}
.wqj-botBox {
    position: absolute;
    top: 940px;
    display: flex;
    padding-bottom: 67px;
}
.ccmt_action {
    overflow: hidden;
}
.load_image {
    width: 30px;
}
.ie {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: url('https://image.gamersky.com/webimg13/zt/22annual/ie.jpg?35454') no-repeat center / 100%;
    z-index: 10;
}
/* .ccmt_msg .qzcmt-piclist.m2{
    display: flex !important;
}

.ccmt_msg .qzcmt-piclist.m5{
    display: flex !important;
} */
.ccmt_msg .qzcmt-piclist{
    display: flex !important;
} 
</style>